import { CONFIRMED_GET_ASSIGNED_HISTORY } from "../types/LeadHistoryType";
import { getAssignedLeadHistory,formatAssignedHistory } from "../../services/LeadHistoryService";
import { showErrorAlert } from "../../services/ErrorHandlingService";

export const getAssignedHistoryAction = (
  pagination = true,
  pageid = 0,
  search_by = "",
  search_keyword = "",
  sort_by = "",
  sort_order = "",
  status = ""
) => {
  return async (dispatch) => {
    try {
      const response = await getAssignedLeadHistory(
        pagination,
        pageid,
        search_by,
        search_keyword,
        sort_by,
        sort_order,
        status
      );

      if (response?.data?.status === "success") {

        const formattedHistory = formatAssignedHistory(response.data.data);
      
        dispatch({
          type: CONFIRMED_GET_ASSIGNED_HISTORY,
          payload: {
            assignedHistory: formattedHistory,
            num_rows: response.data.num_rows || 0,
          },
        });
      
      } else {
        showErrorAlert("Failed to fetch assigned history");
      }
    } catch (error) {
      console.error("Assigned History API Error:", error);
      showErrorAlert("API Error");
    }
  };
};
